{
  "title": "Contact Support",
  "form": {
    "consent": "By submitting your information, you agree to be contacted by an Ande representative."
  },
  "notifications": {
    "sent": {
      "title": "Sent!",
      "body": "Thanks for your submission. We'll get back to you shortly."
    }
  }
}
